<template>
  <div :class="mainClasses">
    <flash fixed></flash>
    <div :class="{'navbar-content': isNotOneStop}">
      <app-header v-if="isNotOneStop" :user="user" v-bind="headerAttrs">
        <template #body>
          <slot name="header"></slot>
        </template>
      </app-header>
      <slot name="secondary-header"></slot>
    </div>
    <slot></slot>

    <app-footer v-if="hasFooter && isNotOneStop">
      <template #body>
        <slot name="footer"></slot>
      </template>
    </app-footer>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import AppHeader from "./header/appHeader.vue";
  import AppFooter from "./footer/appFooter.vue";
  import {Hash} from "../interfaces/hashInterfaces";
  import Flash from "../../common/components/flash/flash.vue"

  export default Vue.extend({
    components: {
      AppHeader,
      AppFooter,
      Flash
    },
    props: {
      user: {
        type: Object,
        default: () => {
          return {};
        }
      },
      headerAttrs: {
        type: Object,
        default: () => {
          return {};
        }
      },
      hasFooter: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {};
    },
    computed: {
      mainClasses(): Hash<boolean> {
        return {};
      }
    }
  });
</script>